// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__15Jt7","spin":"Spinner_spin__s-XRU","container":"Spinner_container__36rKj"};